<div class="forgot-password-container">
  <div class="card">
    <div class="card-header">
      <h2>Forgot Password</h2>
      <p class="subtitle">Reset your password using OTP verification</p>
    </div>

    <div class="card-body">
      <!-- Step 1: Send OTP -->
      @if (!otpSent) {
        <div class="otp-section">
          <div class="info-box">
            <i class="info-icon">ℹ️</i>
            <p>Click the button below to receive an OTP code to your registered email/phone.</p>
          </div>
          <button
            type="button"
            class="btn btn-primary btn-block"
            (click)="onSendOtp()"
            [disabled]="sendingOtp">
            @if (!sendingOtp) {
              <span>Send OTP</span>
            }
            @if (sendingOtp) {
              <span>
                <i class="spinner"></i> Sending OTP...
              </span>
            }
          </button>
        </div>
      }

      <!-- Step 2: Enter OTP and New Password -->
      @if (otpSent) {
        <form [formGroup]="forgotPasswordForm">
          <div class="success-box">
            <i class="success-icon">✓</i>
            <p>OTP has been sent successfully! Please check your email/phone.</p>
          </div>
          <!-- OTP Code Field -->
          <div class="form-group">
            <label for="otpCode">
              OTP Code <span class="required">*</span>
            </label>
            <input
              type="text"
              id="otpCode"
              formControlName="otpCode"
              class="form-control"
              placeholder="Enter OTP code"
              maxlength="6"
              [class.is-invalid]="form['otpCode'].invalid && form['otpCode'].dirty"
              />
              @if (form['otpCode'].invalid && form['otpCode'].dirty) {
                <div class="invalid-feedback">
                  @if (form['otpCode'].errors?.['required']) {
                    <div>OTP code is required</div>
                  }
                  @if (form['otpCode'].errors?.['minlength']) {
                    <div>OTP must be at least 4 digits</div>
                  }
                </div>
              }
              <!-- Resend OTP -->
              <div class="resend-otp-section">
                <button
                  type="button"
                  class="btn-link"
                  (click)="onResendOtp()"
                  [disabled]="countdown > 0 || sendingOtp">
                  @if (countdown > 0) {
                    <span>Resend OTP in {{ countdown }}s</span>
                  }
                  @if (countdown <= 0 && !sendingOtp) {
                    <span>Resend OTP</span>
                  }
                  @if (sendingOtp) {
                    <span>Sending...</span>
                  }
                </button>
              </div>
            </div>
            <!-- New Password Field -->
            <div class="form-group">
              <label for="newPassword">
                New Password <span class="required">*</span>
              </label>
              <div class="password-input-wrapper">
                <input
                  [type]="showPassword[0] ? 'text' : 'password'"
                  id="newPassword"
                  formControlName="newPassword"
                  class="form-control"
                  placeholder="Enter new password"
                  (paste)="disablePaste($event)"
                  [class.is-invalid]="form['newPassword'].invalid && form['newPassword'].dirty"
                  />
                  <button
                    type="button"
                    class="password-toggle"
                    (click)="onPasswordToggle(0)">
                    {{ showPassword[0] ? '👁️' : '👁️‍🗨️' }}
                  </button>
                </div>
                <!-- Password Requirements -->
                @if (form['newPassword'].touched) {
                  <div class="password-requirements">
                    <small [class.valid]="!form['newPassword'].errors?.['required'] && !form['newPassword'].errors?.['minlength']">
                      ✓ At least 8 characters
                    </small>
                    <small [class.valid]="!form['newPassword'].errors?.['hasNumber']">
                      ✓ Contains a number
                    </small>
                    <small [class.valid]="!form['newPassword'].errors?.['hasCapitalCase']">
                      ✓ Contains uppercase letter
                    </small>
                    <small [class.valid]="!form['newPassword'].errors?.['hasSmallCase']">
                      ✓ Contains lowercase letter
                    </small>
                    <small [class.valid]="!form['newPassword'].errors?.['hasSpecialCharacters']">
                      ✓ Contains special character
                    </small>
                  </div>
                }
              </div>
              <!-- Confirm Password Field -->
              <div class="form-group">
                <label for="confirmPassword">
                  Confirm Password <span class="required">*</span>
                </label>
                <div class="password-input-wrapper">
                  <input
                    [type]="showPassword[1] ? 'text' : 'password'"
                    id="confirmPassword"
                    formControlName="confirmPassword"
                    class="form-control"
                    placeholder="Confirm new password"
                    (paste)="disablePaste($event)"
                    [class.is-invalid]="(form['confirmPassword'].invalid || forgotPasswordForm.errors?.['passwordMismatch']) && form['confirmPassword'].dirty"
                    />
                    <button
                      type="button"
                      class="password-toggle"
                      (click)="onPasswordToggle(1)">
                      {{ showPassword[1] ? '👁️' : '👁️‍🗨️' }}
                    </button>
                  </div>
                  @if (forgotPasswordForm.errors?.['passwordMismatch'] && form['confirmPassword'].dirty) {
                    <div class="invalid-feedback">
                      Passwords do not match
                    </div>
                  }
                </div>
                <!-- Action Buttons -->
                <div class="form-actions">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="onCancelAndBack()"
                    [disabled]="submitted">
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    (click)="onChangePassword()"
                    [disabled]="submitted || forgotPasswordForm.invalid">
                    @if (!submitted) {
                      <span>Reset Password</span>
                    }
                    @if (submitted) {
                      <span>
                        <i class="spinner"></i> Resetting...
                      </span>
                    }
                  </button>
                </div>
              </form>
            }
          </div>
        </div>
      </div>